export default{
  "你好，请登录": "Hello, please login",
  "免费注册": "Free registration",
  "你好": "hello",
  "退出": "quit",
  "个人中心": "Individual center",
  "我的订单": "My order",
  "优惠券": "coupon",
  "我的发票": "My invoice",
  "BOM需求": "BOM requirement",
  "账号管理": "Account management",
  "我的收货地址": "My shipping address",
  "我的积分": "My integral",
  "我的足迹": "My tracks",
  "QQ咨询": "QQ consultation",
  "客服": "Customer service",
  "收藏网址": "Favorite website",
  "商户后台": "Merchant back office",
  "退出提示": "Exit prompt",
  "是否确认退出": "Do you confirm exit?",
  "取 消": "cancellation",
  "确 定": "determinate",
  "骏芯商城": "Junxin Mall",
  "请输入内容": "Please enter content",
  "全部商品": "All goods",
  "骏芯自营": "Junxin self-management",
  "爆款推荐": "Explosive recommendation",
  "成品方案": "Finished product scheme",
  "简体中文": "Zh",
  "英语": "En",
  "俄语": "Ru",
  "Hi,上午好": "Hi, good morning",
  "欢迎来到骏芯商城": "Welcome to Junxin Mall",
  "登录": "Log in",
  "注册": "Sign in",
  "全部商品分类": "categories",
  "现货库存": "Actuals",
  "爆款推荐": "Hot",
  "热": "hot",
  "骏芯秒杀": "Flsh Sale",
  "爆": "Hot",
  "镜头模组": "Lens module",
  "成品方案": "Scheme",
  "兑换专区": "Exchange",
  "技术论坛": "forum",
  "HDI板": "HDI",
  "入驻骏芯": "Settled in",
  "加入": "join",
  "专业元器件交易商城": "",
  "原装正品·服务优质·供应稳定": "",
  "请输入需要搜索的内容": "Please enter content",
  "极速BOM配单": "BOM",
  "BOM文件上传": "File Upload",
  "点击上传Excel文件": " Upload",
  "点击上传图片": "Image",
  "BOM标准模板下载": "Template Download",
  "下载": "Download",
  "我的订单": "My order",
  "查看我的订单": "View",
  "已签到": "Signed in",
  "点击签到": "Click to sign in",
  "签到": "Sign-in",
  "连续签到": "",
  "天": "day",
  "签到领积分": "integral",
  "成交记录": "Record",
  "全部成交": "orders",
  "单": "",
  "积分商城": "Points Mall",
  "积分兑换": "Exchange",
  "热门型号": "Popular model",
  "TOP": "TOP",
  "榜": "A list of",
  "扫微信二维码咨询客服": "Scan wechat QR code to consult customer service",
  "二维码": "Two-dimensional code",
  "客户经理": "Account manager",
  "在线客服电话": "Online customer service phone",
  "在线客服QQ": "Online customer service QQ",
  "工作时间": "Working hours",
  "投诉电话": "Complaint telephone",
  "咨询客服": "",
  "购物车": "",
  "优惠劵": "",
  "足迹": "",
  "投诉": "",
  "顶部": "",
  "意见反馈": "feedback",
  "关于我们": "About us ",
  "好":"G",
  "海量现货": "Massive Inventory",
  "40万现货SKU": "40 thousand inventory SKU",
  "品类不断扩充": "Category expansion",
  "快": "F",
  "闪电发货": "Fast delivery",
  "科技智能大仓储": " Technology and intelligent warehouse",
  "4小时快速交货": "4 hour fast delivery",
  "好": "G",
  "严控渠道": "Strict control of channels",
  "仅从原厂和代理商进货": "only from original manufacturers and agents",
  "每一颗料均可原厂追溯": "Each material can be traced back to the original factory",
  "省": "S",
  "降低成本": "Lower cost",
  "明码标价节省时间成本": "Saves time and cost",
  "一站式采购正品元器件": "One-stop purchase of genuine components",
  "联系我们": "Contact us",
  "企业QQ": "Enterprise QQ",
  "服务时间：24小时在线": "Service hours: 24 hours online",
  "2011-2022 骏芯有限公司 版权所有": "2011-2022 Junxin Co., LTD. All rights reserved",
 
  "购物指南":"Shopping Directory",
  "顾客必读":"Customer must read",
  "购物流程":"Shopping process",
  "商品搜索":"Product Search",
  "会员等级":"Membership level",
  "支付&配送":"Payment&Delivery",
  "在线支付":"Online payment",
  "上门自提":"Door-to-door pick-up",
  "快递运输":"Express transportation",
  "领券中心":"Voucher collection center",
  "特色服务":"Featured Services",
  "订货服务":"Ordering Services",
  "进度跟踪":"Progress tracking",
  "质量保证":"quality assurance",
  "售后服务":"after-sale Services",
  "服务投诉":"Service Complaints",
  "订单何时出库":"When will the order be shipped out",
  "送货和验货":"Delivery and inspection",
  "特别说明":"Specification ",
  "隐私保护政策":"",
  "网站使用条款":"",
  "网站免责声明":"",
  "关于我们":"About us",
  "关于骏芯":"Contract Download",
  "骏芯直播":"Junxin Live",
  "意见反馈":"Feedback",
  // "":"",
  // "":"",

  
"上一张":"previous",
"下一张":"Next",

//addAddress.vue
"选择收货地址":"Please select the shipping address",
"收":"收",
"默认地址":"Default",
"+新增收货地址":"+Add a new address",
"收货地址":"Shipping address",
"所在区域":"Region",
"请选择活动区域":"Please select an active area",
"详细地址":"Detailed address",
"无需重复填写省市区，小于75个字":"No need to repeat the province and city, less than 75 words",
"收货人姓名":"Name of the consignee",
"不能为昵称、X先生、X小姐等，请使用真实姓名":"Cannot be a nickname, Mr. X, Miss X, etc. Please use your real name",
"手机号":"phone number",
"手机号码、电话号码必须填一项":"Mobile phone number, telephone number must fill in a field",
"保存地址":"Save address",
"取消":"Cancellation",
//coupon.vue  
"可使用的优惠券":"Coupons that can be used",
"没有数据":"No data",
"折":"fold",
"免邮费":"Free postage",
"可用":"可usable用",
"满":"full",
"立即使用":"Immediate use",
"已使用的优惠券":"Coupons that have been used",
"已使用":"Have been used",
"已失效的优惠券":"Expired coupons",
"已失效":"Became invalid",
"立即使用":"Immediate use",

//personal-left.vue
"个人中心":"Personal Center",
"我的订单":"MyOrder",
"我的优惠券":"MyCoupon",
"我的发票":"MyInvoice",
"账号管理":"AccountManagement",
"我的收货地址":"MyShippingAddress",
"我的积分":"MyPoints",
"足迹":"",

//seckill.vue
// "骏芯秒杀":"骏芯秒杀",
"点场":"Field of points",
// "距开始":"距开始",
// "距结束":"距结束",
"最新帖子":"Latest post",
"更多":"more",
//views/lensMod/index.nue
"品牌":"brand",
"分类":"sort",
//login.vue
"注册账号":"Register",
"输入手机号":"Enter mobile number",
"请输入验证码":"Please enter the verification code",
"获取短信验证码":"Obtain the SMS verification code",
"请输入密码":"Please enter password",
"登录/注册":"Login/Registration",
"同意网站":"Consent site",
"《隐私权协议》":"《Privacy agreement》",
"《骏芯平台服务协议》":"《Junxin platform service agreement》",
"和":"and",
"已有账号，去":"Already have an account. Go",
// "登录":"Log in",
"已阅读":"Have read",

//resetpwd.vue
"忘记密码":"Forgot password",
"请输入新密码":"Please enter your new password",
"记得密码，去":"Remember the password. Go",

//signin.vue

"密码登录":"Password login",
"验证码登录":"Verification code login",
//{{$t('')}}
//goods.vue
"型号":"Model",
"品牌":"Brand",
"类目":"Category",
"批次":"Batch",
"增量":"Increment",
"数据手册":"DataBook",
"点击下载":"ClickDownload",
"暂未添加,敬请期待":"Not added yet, please stay tuned",
"阶梯数":"LadderNumber",
"阶梯价格":"LadderPrice",
"可替代产品":"AlternativeProducts",
"描述":"Description",
"现货库存":"Actuals",
"起订量":"MinimumOrderQuantity",
"近期销量":"RecentSales:",
"采购数量":"PurchaseQuantity",
"总价":"Total price",
"加入购物车":"AddToCart",
"立即购买":"BuyNow",
"产品描述":"ProductDescription",
"规格":"specification",
"参数":"argument",
"PDF数据手册":"PDFDataSheet",
"数据手册下载":"DataSheetDownload",
"上一页":"Previous",
"下一页":"Next page",
"加入购物车成功!":"Add to cart successfully!",
"进入":"enter",
"购物车结算":"Shopping cart billing",

//details.vue

"热门产品":"Hot product",
"价格":"Price",

//feedback.nue
"骏芯视频":"video",

//list.vue
"首页":"Home page",
"问题反馈:":"Home page",
"首页":"Home page",
"首页":"Home page",
"首页":"Home page",

//newsInfo.vue
"问题反馈:":"Problem feedback:",
"上传图片":"Upload pictures",
"联系方式：":"Contact information:",
"邮箱：":"mailbox:",
"立即反馈":"Immediate feedback",
"下载":"Download",

//find.vue
"验证身份":"Verify identity",
"修改手机":"Modify mobile phone",
"完成":"complete",
"手机验证码验证 账号":"Mobile phone verification code verification Account number",
"为确认是你本人操作，请完成以下验证":"In order to confirm that you are the operator, please complete the following verification",
"手机验证码":"Mobile phone verification code",
"发送验证码":"Send verification code",
"确定":"OK",
"更改手机号":"Change mobile number",
"绑定成功":"Binding successful",
"手机号更改成功":"The mobile phone number is changed successfully",
//findCode.vue
"设置新密码":"Set a new password",
"账号188******78为确认是你本人操作，请完成以下验证":"Confirm that it is your own operation, please complete the following verification",
"新密码设置成功":"The new password is set successfully",

//personal/index.vue

"点击编辑":"Edit",
"绑定手机号":"Associate a mobile phone number",
"昵称":"Nickname",
"签名":"Signature",
"邮箱":"Email",
"学历":"Education",
"公司名称":"Company name",
"公司名称:":"Company name:",
"请输入昵称":"Please enter a nickname",
"请选择":"Please select",
"请输入签名":"Please enter your signature",
"请输入公司名称":"请输入公司名称",
"保存提交":"Save the submission",
"点击添加":"Add to",

//integral.vue
"全部积分":"All points",
"签到积分":"Check-in score",
"我的积分":"MyPoints",
"进入兑换专区":"Enter the exchange area",
"来源/用途":"Source/Use",
"积分":"Points",
"剩余积分":"Remaining points",
"时间":"Time",
"获取积分":"Get points",
"扣除积分记录":"Deduction of integral record",

//myFp.vue
"我的发票列表":"List of my invoices",
"没有数据":"no data",
"对应商品订单":"Corresponding merchandise order",
"查看详情":"View details",
"发票抬头":"Invoice title",
"开票金额(元)":"Invoice amount (Yuan)",
"发票税率(%)":"Invoice tax rate (%)",
"发票内容":"Invoice content",
"备注":"remark",
"审核中":"Under review",
"已出票":"Ticket has been issued.",

//order.vue

"所有订单":"All orders",
"商城":"Mall",
"单价（含税）":"Unit price",
"数量":"Quantity",
"总计（元）":"Total (yuan)",
"订单状态":"Order status",
"操作":"Controls",
"订单号":"Order number",
"下单时间":"Order time",
"普通商品":"Ordinary products",
"秒杀商品":"Instant goods",
"爆款商品":"Explosive goods",
"新品":"new",
"成品":"Finished product",
"积分商品":"Integral goods",
"去支付":"Go pay",
"查看订单":"View order",
"确认收货":"Confirm receipt",
"替代方案":"Alternative scheme",
"再次购买":"repurchase",
"待发货":"Goods waiting to be sent",
"待收货":"Wait to be received",
"待评论":"To be reviewed",
"已完成":"completed",
"售后订单":"After-sale order",
"可开票":"Invoice available",
"去开票":"Go to make out an invoice",
"已提交,点击查看":"Submitted, click to view",
"开票":"Make out an invoice",
"金额":"amount",
"元":"yuan",
"开票主体":"Issuing body",
"请输入开票主体":"Please enter the issuing body",
"发票类型":"Invoice type",
"请选择发票类型":"Please select the invoice type",
"税率":"Tax rate",
"发票抬头":"Invoice title",
"请输入发票抬头":"Please enter the invoice title",
"开票内容":"Billing content",
"请输入开票内容":"Please enter the billing information",
"请输入备注":"Please enter remarks",
"确认开票":"Confirmation billing",
//orderInfo.vue

"已取消":"Cancelled",
"待支付":"To be paid",
"待付款":"To be paid",
"1、提交订单":"Submit Order",
"2、付款成功":"Payment successful",
"3、仓库发货":"Warehouse delivery",
"4、确认收货":"Confirm receipt",
"当前状态":"Current status",
"立即兑换":"Immediate exchange",
"立即支付":"Pay now",
"删除订单":"Delete the order",
"立即收货":"Immediate delivery",
"订单详情":"Order details",
"订单收货地址":"Order delivery address",
"物流单号":"Logistics tracking number",
"订单类型":"Order type",
"付款积分":"Payment points",
"付款金额":"Payment amount",
"是否开票":"Invoice or not",
"已提交":"submitted",
"订单":"Orders",
"商品信息":"Product information",
"分类/描述/参数品牌":"Parameter",
"优惠":"preferential",
"小计":"subtotal",
"申请退款":"Refund applied",
"已申请退款":"Refund applied",
"退货":"Return goods",
"已退款":"Refunded",
"商品应付总计":"Total amount payable for goods",
"运费":"freight",
"优惠券抵扣金额":"The amount is deducted by the coupon",
"应付积分":"Points payable",
"应付金额":"Amount due",
"退货信息":"Return information",

//orderSucceed.vue
"您的订单已支付成功":"Your order has been paid successfully",
"安全提醒:请不要将银行卡、密码、手机验证码提供给他人":"Security reminder: Please do not provide your bank card, password, and mobile phone verification code to others",
// "查看我的订单":"View my order",

//allProducts.vue

"功能":"Feature",
"原装正品":"Original and genuine",
"闪电配送":"闪电配送",
"售后无忧":"Lightning distribution",
"商品总数":"Total number",
"按钮":"Button",
"供应商型号":"Supplier model",
"类别":"category",
"厂牌":"label",
"货期:内地 1工作日":"Delivery time: Mainland 1 working day",
"价格梯度":"Price gradient",
"库存":"inventory",
"合计":"total",

//endProduct.vue
"成品方案":"Finished product scheme",
"名称":"name",
"简介":"intro",
"文档版本":"Document version",
"发布时间":"Release time",
"新品推荐":"New product recommendation",
"即将开始":"Be about to start",
"已经结束":"Have come to an end",
"正在秒杀":"Instant kill",
"距离结束":"End of distance",
"已售":"Sold out",
"已结束":"Already ended",
"未开始":"Not yet started",
"立即抢购":"Snap up",

//account.vue
"收":"closed",
"提交订单":"Submit an order",
"返回购物车修改":"Back to cart modification",
"应付":"Cope with",
"优惠券抵扣金额":"The amount is deducted by the coupon",
"优惠券折扣":"Coupon discount",
"商品券":"Merchandise coupon",
"立即发货":"Immediate delivery",
"货期":"Delivery time",
"确认商品信息":"Confirm product information",

"订单提交成功，现在只差最后一步啦!":"Order submitted successfully, now only the last step!",
"支付金额":"Amount paid",
"积分支付":"Point payment",

"去结算":"Go to Result",
"总计（不含运费)":"Total (excluding freight)",
"件":"a",
"已选商品":"Selected goods",
"全部":"All",
"删除选中商品":"Remove selected items",
"删除":"delete",
"图片":"picture",
"购物车内暂时没有商品，您可以":"There are no products in the shopping cart. You can",
"去首页查找、挑选您需要的产品":"Go to the home page to find and select the products you need",

"申请入驻":"Apply for entry",

"领券立减":"Coupon immediately reduced",
"代理分销品牌":"Agent distribution brand",
"元可用":"Meta available",
"还剩下":"Have left",
"张":"zhang",
"立即领取":"Immediate claim",
"立即申请":"Apply now",

"我是贸易商":"I'm a trader",
"我是工厂":"I am the factory",
"我是代理商":"I am the agent.",
"我是原厂":"I am the original factory",
"联系方式:":"Contact information:",
"类型":"Type:",
"联系人:":"Contact person:",
}


// WEBPACK FOOTER //
// ./src/lang/en.js